import { request } from '../request'
import { Rating } from '../types'

export class RatingsService {

  getRating(customerId: number, postId: number): Promise<Rating> {
    return request.get(`/api/customers/${customerId}/posts/${postId}/rating.json`)
  }

  getRatings(customerId: number, postIds: number[]): Promise<Rating[]> {
    return request.get(`/api/customers/${customerId}/ratings.json`, { post_ids: postIds.join(',') })
  }

  updateRating(customerId: number, postId: number, value: number): Promise<Rating> {
    return request.put(`/api/customers/${customerId}/posts/${postId}/rating.json`, { rating: { value } })
  }
}
